export default __webpack_public_path__ + "static/media-fbe5ad414e77021ca8d8f7949d39db3d.png";